// extracted by mini-css-extract-plugin
export default {"collapsible":"ancillary-form_collapsible__mYeOn","formHeader":"ancillary-form_formHeader__WkWHw"};